module.exports = __webpack_public_path__ + "img/TSN_05_01.1cc9ad56.png";